import angular from 'angular';

import EditTeacherAccountController from './edit-teacher-account-controller';

const editTeacherAccount = angular.module('editTeacherAccount', []);
editTeacherAccount.controller('EditTeacherAccountController', EditTeacherAccountController);

export default editTeacherAccount.name;
